(function (Drupal, $, settings) {
  Drupal.behaviors.authStatus = {
    attach: function attach(context) {
      const data = localStorage.getItem('persist:root')
      if (data && data.length) {
        const json = JSON.parse(data);
        const appState = JSON.parse(json.appState);
        if (appState.authentication && appState.authentication.firstname.length) {
          $('.user-block__signin span').text(Drupal.t('Hi @username', { '@username': appState.authentication.firstname}));
          $('.user-block__signin a').attr('href', '/order/rewards')
          $('.layout__region--mobile-header .user-block__signin span').text(Drupal.t('My Account'));

        }
      }
    }
  }
})(Drupal, jQuery, drupalSettings);
